import React, { useState, useEffect, useCallback } from 'react';
import liff from '@line/liff';
import { buildApiUrl } from '../../utils/apiBase';
import MedicineNotifyPage from './MedicineNotifyPage';

const BRAND_ORANGE = '#FF6B35';

const NotifyPage = ({ appUser, onBack }) => {
  const [subPage, setSubPage] = useState(null);
  const [medicineCounts, setMedicineCounts] = useState(0);

  const fetchCounts = useCallback(async () => {
    try {
      const token = liff.getAccessToken();
      if (!token) return;
      const res = await fetch(buildApiUrl('/api/medicines'), {
        headers: { Authorization: `Bearer ${token}` },
      });
      const json = await res.json();
      setMedicineCounts(json.medicines?.length || 0);
    } catch (e) {
      console.error('fetchCounts error:', e);
    }
  }, []);

  useEffect(() => { fetchCounts(); }, [fetchCounts]);

  const handleClose = () => {
    if (onBack) { onBack(); return; }
    try { liff.closeWindow(); } catch { window.history.back(); }
  };

  if (subPage === 'medicine') {
    return (
      <MedicineNotifyPage
        appUser={appUser}
        onBack={() => { setSubPage(null); fetchCounts(); }}
      />
    );
  }

  const NOTIFY_CATEGORIES = [
    {
      key: 'medicine',
      icon: '💊',
      title: 'ยาของฉัน',
      subtitle: 'แจ้งเตือนเวลากินยาทุกวัน',
      count: medicineCounts,
      countLabel: 'รายการ',
      color: '#fff4f0',
      borderColor: '#ffe0d0',
      enabled: true,
    },
    // Future categories slot in here:
    // { key: 'appointment', icon: '📅', title: 'นัดหมาย', subtitle: 'แจ้งเตือนนัดแพทย์และกิจกรรม', enabled: false },
    // { key: 'bill', icon: '🧾', title: 'บิลและค่าใช้จ่าย', subtitle: 'แจ้งเตือนวันครบกำหนดชำระ', enabled: false },
  ];

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f7f8fa', paddingBottom: 40 }}>
      {/* Header */}
      <div style={{ backgroundColor: BRAND_ORANGE, padding: '20px 16px 16px', position: 'sticky', top: 0, zIndex: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <p style={{ margin: 0, fontSize: 10, color: 'rgba(255,255,255,0.75)', fontWeight: 700, letterSpacing: '0.8px' }}>
              MEMMANY BOT
            </p>
            <h1 style={{ margin: '2px 0 0', fontSize: 20, fontWeight: 700, color: '#fff' }}>การแจ้งเตือน</h1>
            <p style={{ margin: '2px 0 0', fontSize: 11, color: 'rgba(255,255,255,0.8)' }}>จัดการการแจ้งเตือนทั้งหมด</p>
          </div>
          <button
            onClick={handleClose}
            style={{ backgroundColor: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 20, padding: '8px 16px', color: '#fff', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}
          >
            กลับ
          </button>
        </div>
      </div>

      <div style={{ padding: 16 }}>
        <p style={{ margin: '0 0 16px', fontSize: 13, color: '#888' }}>เลือกประเภทการแจ้งเตือนที่ต้องการจัดการ</p>

        {NOTIFY_CATEGORIES.map((cat) => (
          cat.enabled ? (
            <button
              key={cat.key}
              onClick={() => setSubPage(cat.key)}
              style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 16, backgroundColor: '#fff', borderRadius: 16, padding: '16px', marginBottom: 12, boxShadow: '0 1px 6px rgba(0,0,0,0.07)', border: `1px solid ${cat.borderColor}`, cursor: 'pointer', textAlign: 'left' }}
            >
              <div style={{ width: 52, height: 52, borderRadius: 14, backgroundColor: cat.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26, flexShrink: 0 }}>
                {cat.icon}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#111' }}>{cat.title}</p>
                <p style={{ margin: '3px 0 0', fontSize: 12, color: '#888' }}>{cat.subtitle}</p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, flexShrink: 0 }}>
                {cat.count > 0 && (
                  <span style={{ fontSize: 13, fontWeight: 700, color: BRAND_ORANGE, backgroundColor: '#fff4f0', borderRadius: 10, padding: '2px 10px' }}>
                    {cat.count} {cat.countLabel}
                  </span>
                )}
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </div>
            </button>
          ) : (
            <div
              key={cat.key}
              style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 16, backgroundColor: '#fafafa', borderRadius: 16, padding: '16px', marginBottom: 12, border: '1px solid #eee', opacity: 0.6 }}
            >
              <div style={{ width: 52, height: 52, borderRadius: 14, backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26, flexShrink: 0 }}>
                {cat.icon}
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#888' }}>{cat.title}</p>
                <p style={{ margin: '3px 0 0', fontSize: 12, color: '#aaa' }}>เร็วๆ นี้</p>
              </div>
              <span style={{ fontSize: 11, fontWeight: 600, color: '#aaa', backgroundColor: '#f0f0f0', borderRadius: 8, padding: '3px 10px' }}>เร็วๆ นี้</span>
            </div>
          )
        ))}
      </div>
    </div>
  );
};

export default NotifyPage;
